import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/compliance-composer")({
  component: lazyRouteComponent(() => import("./-pages/admin.compliance-composer")),
  head: () => ({
    meta: [
      { title: "Compliance Composer · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
